import React from 'react'

const Manual_inventario_conteo_inventario = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
    <div className="mt-16">
      <h2 className="font-bold xl-text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
        Inventario - Conteo de Inventario
      </h2>
      <p className="text-lg text-gray-700 mb-6">
        El guía proporciona pasos claros para optimizar el conteo de inventario, incluyendo la configuración de nombres, fechas, y estados, así como la eficiente adición de productos. Aprenderás a mantener registros precisos y actualizados, mejorando la organización y eficiencia en la gestión del stock.
      </p>
      <iframe
        src="https://scribehow.com/embed/Inventario__Conteo_de_Inventario__qTN6QQpiQZy2IZjuNDSM2A?as=scrollable"
        className="scribe-iframe-general-39"
        width="100%"
        height="5520"
        allowFullScreen
        style={{ border: 0, minHeight: '640px' }}
      ></iframe>
    </div>
  </div>
  )
}

export default Manual_inventario_conteo_inventario